import { render } from "./tableAlerts.vue?vue&type=template&id=12822642&scoped=true"
import script from "./tableAlerts.vue?vue&type=script&lang=js"
export * from "./tableAlerts.vue?vue&type=script&lang=js"

import "./tableAlerts.vue?vue&type=style&index=0&id=12822642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12822642"]])

export default __exports__